{
  "AUTOMATION": {
    "HEADER": "Αυτοματισμός",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Προσθήκη Κανόνα Αυτοματισμού",
    "LOADING": "Λήψη κανόνων αυτοματισμού",
    "ADD": {
      "TITLE": "Προσθήκη Κανόνα Αυτοματισμού",
      "SUBMIT": "Δημιουργία",
      "CANCEL_BUTTON_TEXT": "Άκυρο",
      "FORM": {
        "NAME": {
          "LABEL": "Όνομα Κανόνα",
          "PLACEHOLDER": "Εισάγετε όνομα κανόνα",
          "ERROR": "Απαιτείται όνομα"
        },
        "DESC": {
          "LABEL": "Περιγραφή",
          "PLACEHOLDER": "Εισάγετε περιγραφή κανόνα",
          "ERROR": "Η περιγραφή απαιτείται"
        },
        "EVENT": {
          "LABEL": "Συμβάν",
          "PLACEHOLDER": "Παρακαλώ επιλέξτε ένα",
          "ERROR": "Απαιτείται συμβάν"
        },
        "PHASE": {
          "LABEL": "Φάση"
        },
        "ORDER": {
          "LABEL": "Σειρά",
          "ERROR": "Απαιτείται σειρά"
        },
        "CONDITIONS": {
          "LABEL": "Προϋποθέσεις"
        },
        "ACTIONS": {
          "LABEL": "Ενέργειες"
        }
      },
      "CONDITION_BUTTON_LABEL": "Προσθήκη Προϋπόθεσης",
      "ACTION_BUTTON_LABEL": "Προσθήκη Ενέργειας",
      "API": {
        "SUCCESS_MESSAGE": "Ο κανόνας αυτοματισμού προστέθηκε με επιτυχία",
        "ERROR_MESSAGE": "Δεν ήταν δυνατή η δημιουργία ενός κανόνα αυτοματισμού, Παρακαλώ δοκιμάστε ξανά αργότερα"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Φάση",
        "ORDER": "Σειρά",
        "NAME": "Όνομα",
        "DESCRIPTION": "Περιγραφή",
        "ACTIVE": "Ενεργή",
        "CREATED_ON": "Δημιουργήθηκε στις",
        "WAIT": "Αναμονή"
      },
      "404": "Δεν βρέθηκαν κανόνες αυτοματισμού",
      "TABS": {
        "ALL": "Όλοι",
        "INSTANT": "Κατά το συμβάν",
        "DELAYED": "Με καθυστέρηση"
      },
      "WAITS": "Αναμονή {duration}"
    },
    "DELETE": {
      "TITLE": "Διαγραφή Κανόνα Αυτοματισμού",
      "SUBMIT": "Διαγραφή",
      "CANCEL_BUTTON_TEXT": "Άκυρο",
      "CONFIRM": {
        "TITLE": "Επιβεβαίωση Διαγραφής",
        "MESSAGE": "Είσαστε σίγουροι για την διαγραφή ",
        "YES": "Ναι, Διέγραψε τον/την ",
        "NO": "Όχι, Κράτησε τον/την"
      },
      "API": {
        "SUCCESS_MESSAGE": "Ο κανόνας αυτοματισμού διαγράφηκε επιτυχώς",
        "ERROR_MESSAGE": "Δεν ήταν δυνατή η διαγραφή του κανόνα αυτοματισμού, Παρακαλώ δοκιμάστε ξανά αργότερα"
      }
    },
    "EDIT": {
      "TITLE": "Επεξεργασία Κανόνα Αυτοματισμού",
      "SUBMIT": "Ενημέρωση",
      "CANCEL_BUTTON_TEXT": "Άκυρο",
      "API": {
        "SUCCESS_MESSAGE": "Ο κανόνας αυτοματισμού ενημερώθηκε επιτυχώς",
        "ERROR_MESSAGE": "Δεν ήταν δυνατή η ενημέρωση του κανόνα αυτοματισμού, Παρακαλώ προσπαθήστε ξανά αργότερα"
      }
    },
    "CLONE": {
      "TOOLTIP": "Κλώνος",
      "API": {
        "SUCCESS_MESSAGE": "Ο αυτοματισμός κλωνοποιήθηκε επιτυχώς",
        "ERROR_MESSAGE": "Δεν ήταν δυνατή η κλωνοποίηση του κανόνα αυτοματισμού, Παρακαλώ δοκιμάστε ξανά αργότερα"
      }
    },
    "FORM": {
      "EDIT": "Επεξεργασία",
      "CREATE": "Δημιουργία",
      "DELETE": "Διαγραφή",
      "CANCEL": "Άκυρο",
      "RESET_MESSAGE": "Η αλλαγή τύπου συμβάντος θα επαναφέρει τις συνθήκες και τα συμβάντα που έχετε προσθέσει παρακάτω"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Πρέπει να έχετε τουλάχιστον μία συνθήκη για να αποθηκεύσετε",
      "CONTACT_CUSTOM_ATTR_LABEL": "Προσαρμοσμένες Ιδιότητες Επαφής",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Προσαρμοσμένες Ιδιότητες Συνομιλίας"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Πρέπει να έχετε τουλάχιστον μία ενέργεια για να αποθηκεύσετε",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Γράψτε το μήνυμά σας εδώ",
      "TEAM_DROPDOWN_PLACEHOLDER": "Επιλογή ομάδων",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Επιλέξτε κιβώτιο email και διεύθυνση αποστολέα",
      "SUBJECT_INPUT_PLACEHOLDER": "Θέμα email",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Επιλέξτε το κιβώτιο SMS από το οποίο θα γίνει η αποστολή",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Εισαγάγετε το κείμενο του SMS",
      "SMS_COUNTER": "{length}/{limit} χαρακτήρες, {segments} SMS (πριν συμπληρωθούν οι μεταβλητές)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Ενεργοποίηση Κανόνα Αυτοματισμού",
      "DEACTIVATION_TITLE": "Απενεργοποίηση Κανόνα Αυτοματισμού",
      "ACTIVATION_DESCRIPTION": "Αυτή η ενέργεια θα ενεργοποιήσει τον κανόνα αυτοματισμού '{automationName}'. Είστε σίγουροι ότι θέλετε να συνεχίσετε;",
      "DEACTIVATION_DESCRIPTION": "Αυτή η ενέργεια θα απενεργοποιήσει τον κανόνα αυτοματισμού '{automationName}'. Είστε σίγουροι ότι θέλετε να συνεχίσετε;",
      "ACTIVATION_SUCCESFUL": "Κανόνας Αυτοματισμού Ενεργοποιήθηκε Επιτυχώς",
      "DEACTIVATION_SUCCESFUL": "Ο Κανόνας Αυτοματισμού Απενεργοποιήθηκε Επιτυχώς",
      "ACTIVATION_ERROR": "Δεν ήταν δυνατή η ενεργοποίηση του Αυτοματισμού, παρακαλώ προσπαθήστε ξανά αργότερα",
      "DEACTIVATION_ERROR": "Δεν ήταν δυνατή η απενεργοποίηση του Αυτοματισμού, παρακαλώ προσπαθήστε ξανά αργότερα",
      "CONFIRMATION_LABEL": "Ναι",
      "CANCEL_LABEL": "Όχι"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Δεν ήταν δυνατή η μεταφόρτωση συνημμένου, παρακαλώ προσπαθήστε ξανά",
      "LABEL_IDLE": "Ανέβασμα επισυναπτόμενου",
      "LABEL_UPLOADING": "Ανέβασμα...",
      "LABEL_UPLOADED": "Επιτυχής Μεταφόρτωση",
      "LABEL_UPLOAD_FAILED": "Αποτυχία Μεταφόρτωσης"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Απαιτείται τιμή",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Αυτή η ενέργεια λειτουργεί μόνο όταν η φάση του κανόνα έχει οριστεί σε «Πριν την επισήμανση».",
      "SKIP_AUTO_LABELING": "Αυτή η ενέργεια λειτουργεί μόνο όταν η φάση του κανόνα έχει οριστεί σε «Πριν την επισήμανση».",
      "MOVE_CONVERSATION_TO_INBOX": "Μόνο οι συζητήσεις email και web chat μπορούν να μετακινηθούν σε κιβώτιο εισερχομένων email, και ένα web chat μόνο αν η επαφή έχει διεύθυνση email. Διαφορετικά η συζήτηση παραμένει εκεί που είναι και προστίθεται ιδιωτική σημείωση.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Ξεκινά μια νέα συζήτηση με την επαφή στο επιλεγμένο κιβώτιο email, της στέλνει το μήνυμα με email και επιλύει τη συζήτηση. Αυτό συμβαίνει κάθε φορά που εκτελείται ο κανόνας. Αν η επαφή δεν έχει διεύθυνση email, δεν αποστέλλεται τίποτα και προστίθεται μια ιδιωτική σημείωση.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Ξεκινά μια νέα συζήτηση με την επαφή στο επιλεγμένο κιβώτιο SMS, της στέλνει το μήνυμα ως SMS και επιλύει τη συζήτηση. Αυτό συμβαίνει κάθε φορά που εκτελείται ο κανόνας. Το μήνυμα είναι απλό κείμενο χωρίς συνημμένα. Αν η επαφή δεν έχει αριθμό τηλεφώνου, δεν αποστέλλεται τίποτα και προστίθεται μια ιδιωτική σημείωση."
    },
    "NOTICES": {
      "AI_PROMPT": "Κάθε ξεχωριστή αξιολόγηση χρεώνεται.",
      "INCOMING_MESSAGES_COUNT": "Αυτό αναφέρεται στον αριθμό των εισερχόμενων μηνυμάτων στη συνομιλία.",
      "OUTGOING_MESSAGES_COUNT": "Αυτό αναφέρεται στον αριθμό των εξερχόμενων μηνυμάτων στη συνομιλία."
    },
    "PHASE": {
      "BEFORE_LABELING": "Πριν την επισήμανση",
      "AFTER_LABELING": "Μετά την επισήμανση"
    },
    "NONE_OPTION": "Κανένα",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Incoming Message",
      "OUTGOING": "Outgoing Message",
      "PRIVATE": "Private Note",
      "AI_SUMMARY": "AI Summary"
    },
    "YES_NO_VALUES": {
      "YES": "Ναι",
      "NO": "Όχι"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Άμεσο μήνυμα Instagram",
      "FACEBOOK_COMMENT": "Σχόλιο Facebook"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Δημιουργήθηκε Συνομιλία",
      "CONVERSATION_UPDATED": "Η Συνομιλία Ενημερώθηκε",
      "MESSAGE_CREATED": "Δημιουργήθηκε Μήνυμα",
      "CONVERSATION_OPENED": "Η Συνομιλία Ανοίχθηκε",
      "CONVERSATION_RESOLVED": "Η Συνομιλία Επιλύθηκε",
      "PHONE_CALL_FINISHED": "Ολοκληρώθηκε Κλήση"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Ανάθεση σε Πράκτορα",
      "ASSIGN_TEAM": "Ανάθεση Ομάδας",
      "ADD_LABEL": "Προσθήκη Ετικέτας",
      "REMOVE_LABEL": "Αφαίρεση Ετικέτας",
      "SEND_EMAIL_TO_TEAM": "Αποστολή Email στην Ομάδα",
      "SEND_EMAIL_TRANSCRIPT": "Αποστολή Μεταγραφής Email",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Αποστολή Αναλυτικής Μεταγραφής Email",
      "MUTE_CONVERSATION": "Σίγαση Συνομιλίας",
      "SNOOZE_CONVERSATION": "Αναβολή Συνομιλίας",
      "RESOLVE_CONVERSATION": "Επίλυση Συνομιλίας",
      "OPEN_CONVERSATION": "Άνοιγμα Συνομιλίας",
      "SEND_WEBHOOK_EVENT": "Αποστολή Συμβάντος Webhook",
      "SEND_ATTACHMENT": "Αποστολή Συνημμένου",
      "SEND_MESSAGE": "Αποστολή Μηνύματος",
      "ADD_NOTE": "Προσθήκη Σημείωσης",
      "CHANGE_PRIORITY": "Αλλαγή Προτεραιότητας",
      "ADD_SLA": "Προσθήκη SLA",
      "SKIP_AUTO_PRIORITY": "Παράλειψη Αυτόματης Προτεραιότητας",
      "SKIP_AUTO_LABELING": "Παράλειψη Αυτόματης Επισήμανσης",
      "AUTO_TRANSLATE": "Μετάφραση Μηνύματος",
      "AUTO_TRANSLATE_CONVERSATION": "Μετάφραση Συνομιλίας",
      "MOVE_CONVERSATION_TO_INBOX": "Μετακίνηση συζήτησης σε κιβώτιο εισερχομένων",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Αποστολή μηνύματος σε νέα συζήτηση",
      "SEND_SMS_IN_NEW_CONVERSATION": "Αποστολή SMS σε νέα συζήτηση",
      "STOP_PROCESSING_RULES": "Διακοπή Επεξεργασίας Κανόνων"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "Φίλτρο AI",
      "MESSAGE_TYPE": "Τύπος Μηνύματος",
      "MESSAGE_CONTAINS": "Περιεχόμενο Μηνύματος",
      "EMAIL": "Email επαφής",
      "INBOX": "Εισερχόμενα",
      "CHANNEL_TYPE": "Τύπος Εισερχομένων",
      "CONVERSATION_LANGUAGE": "Γλώσσα Συνομιλίας",
      "PHONE_NUMBER": "Αριθμός Τηλεφώνου",
      "STATUS": "Κατάσταση",
      "BROWSER_LANGUAGE": "Γλώσσα Περιήγησης",
      "MAIL_SUBJECT": "Θέμα Email",
      "COUNTRY_NAME": "Χώρα",
      "MARKETPLACE_COUNTRY": "Χώρα marketplace",
      "REFERER_LINK": "Σύνδεσμος αναφοράς",
      "ASSIGNEE_NAME": "Ανάδοχος",
      "TEAM_NAME": "Ομάδα",
      "PRIORITY": "Προτεραιότητα",
      "CALL_DIRECTION": "Κατεύθυνση Κλήσης",
      "MISSED_CALL": "Αναπάντητη Κλήση",
      "MISSED_CALL_COUNT": "Αριθμός αναπάντητων κλήσεων",
      "MESSAGE_SOURCE_TYPE": "Τύπος Πηγής Μηνύματος",
      "INCOMING_MESSAGE_COUNT": "Αριθμός εισερχόμενων μηνυμάτων",
      "OUTGOING_MESSAGE_COUNT": "Αριθμός εξερχόμενων μηνυμάτων",
      "LABEL": "Ετικέτα",
      "EMAIL_RECIPIENTS": "Παραλήπτης Email",
      "EMAIL_AUTO_REPLY": "Το Email είναι αυτόματη απάντηση",
      "ATTACHMENT_EXTENSION": "Επέκταση Συνημμένου",
      "EXTENSION": "Κληθείς εσωτερικός αριθμός",
      "WORKING_HOURS": "Εντός ωρών εργασίας",
      "AGENT_REPLIED": "Πράκτορας απάντησε από την αλλαγή κατάστασης"
    },
    "WAIT": {
      "RUN_LABEL": "Εκτέλεση ενεργειών",
      "INSTANT": "Κατά το συμβάν",
      "DELAYED": "Με καθυστέρηση",
      "TRIGGER_LABEL": "Αναμονή μέχρι",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Μια συνομιλία παραμένει σε μια κατάσταση",
        "CUSTOMER_UNRESPONSIVE": "Ο πελάτης δεν απαντά σε έναν πράκτορα",
        "AGENT_UNRESPONSIVE": "Ο πελάτης δεν λαμβάνει απάντηση από πράκτορα"
      },
      "STATUS_LABEL": "Κατάσταση",
      "STATUSES": {
        "OPEN": "Ανοιχτή",
        "PENDING": "Σε εκκρεμότητα",
        "SNOOZED": "Σε αναβολή",
        "RESOLVED": "Επιλυμένη"
      },
      "DELAY_LABEL": "Χρόνος αναμονής",
      "DELAY_ERROR": "Εισαγάγετε χρόνο αναμονής από 1 λεπτό έως 30 ημέρες",
      "DURATION": {
        "MINUTES": "{count} λεπ.",
        "HOURS": "{count} ώρ.",
        "DAYS": "{count} ημ."
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Οι ενέργειες εκτελούνται όταν μια συνομιλία βρίσκεται στην κατάσταση {status} για {duration}. Μια αλλαγή κατάστασης νωρίτερα τις ακυρώνει. Οι ετικέτες, οι ώρες εργασίας και οι απαντήσεις πράκτορα ελέγχονται όταν λήξει η αναμονή.",
        "CUSTOMER_UNRESPONSIVE": "Οι ενέργειες εκτελούνται όταν ο πελάτης δεν έχει απαντήσει για {duration} στο μήνυμα ενός πράκτορα. Μια απάντηση του πελάτη τις ακυρώνει· ένα νέο μήνυμα του πράκτορα ξεκινά ξανά την αναμονή.",
        "AGENT_UNRESPONSIVE": "Οι ενέργειες εκτελούνται όταν ο πελάτης περιμένει {duration} χωρίς απάντηση πράκτορα. Μια απάντηση του πράκτορα τις ακυρώνει."
      }
    }
  }
}
